const GetTempWorkersUrl = `/admin/api/temp_workers`;
const PostTempWorkerUrl = `/admin/api/temp_workers`;
const GetTempWorkerUrl = (tempWorkerId: number) => `/admin/api/temp_workers/${tempWorkerId}`;
const PutArchiveTempWorkerUrl = (tempWorkerId: number) => `/admin/api/temp_workers/${tempWorkerId}/archive`;
const PostSyncTempWorkerUrl = (tempWorkerId: number) => `/admin/api/temp_workers/${tempWorkerId}/synchronize`;
const PutTempWorkerUrl = (tempWorkerId: number) => `/admin/api/temp_workers/${tempWorkerId}`;
const GetExportUrl = (exportId: number) => `/admin/api/anael/exports/${exportId}`;

export { GetTempWorkersUrl, PostTempWorkerUrl, GetTempWorkerUrl, PutArchiveTempWorkerUrl, PostSyncTempWorkerUrl, PutTempWorkerUrl, GetExportUrl };